<div class="card pf-card mb-3" id="mlp-map-scroll-to">
    <div class="card-header" role="tab">
        <h2 class="sg-heading__h4 mb-0">Location, Opening Hours and Prices</h2>
    </div>

    <div class="card-body">
        <ng-template class="cursor pointer">
            <span class="d-md-none">Map, Hours, Prices</span>
            <span class="d-none d-md-inline"
                >Location, Opening Hours and Prices</span
            >
        </ng-template>

        <div class="row">
            <div class="col-sm-12">
                <div *ngIf="isBrowser">
                    <div class="staticMap" *ngIf="!showDynamicMap">
                        <mlp-google-maps-static
                            [config]="staticMapConfig"
                            (click)="changeMapsToDynamic()"
                        ></mlp-google-maps-static>

                        <div class="staticMap--info w-100">
                            <small
                                ><em>
                                    <strong class="d-none d-md-inline ml-2"
                                        ><mlp-ng-icon
                                            name="cursor"
                                            *ngIf="showPointerIcon"
                                        ></mlp-ng-icon
                                        >{{ staticMapMessage }}</strong
                                    >
                                    <strong class="d-md-none ml-1"
                                        ><mlp-ng-icon
                                            name="cursor"
                                            *ngIf="showPointerIcon"
                                        ></mlp-ng-icon
                                        >{{ staticMapMessageMobile }}</strong
                                    >
                                </em></small
                            >
                        </div>
                    </div>

                    <div *ngIf="showDynamicMap">
                        <div
                            *ngIf="isMapLoading"
                            class="row align-items-center justify-content-center interactiveMap--loading"
                        >
                            <mlp-loading
                                *ngIf="!isUnableToLoadMap"
                            ></mlp-loading>
                            <div *ngIf="isUnableToLoadMap">
                                Unable to load interactive map
                            </div>
                        </div>

                        <agm-map
                            [latitude]="lat"
                            [longitude]="lng"
                            [zoom]="zoom"
                            [scrollwheel]="false"
                            (mapReady)="hideLoadingIcon($event)"
                        >
                            <agm-marker
                                [latitude]="lat"
                                [longitude]="lng"
                            ></agm-marker>
                        </agm-map>
                    </div>
                </div>

                <p>
                    <mlp-ng-icon name="style-two-pin-marker"></mlp-ng-icon>
                    {{ venueService.venueData | venueInlineAddress }}
                </p>
            </div>

            <hr />

            <div
                class="col-sm-6"
                *ngIf="venueService.venueData?.data.attributes.nearest_tube"
            >
                <div *ngIf="!isActivePlaces">
                    <h3 class="sg-heading__h4">Prices</h3>
                    <ul
                        class="list-unstyled"
                        *ngIf="
                            venueService.pitchData?.data.attributes.payment
                                .length > 0
                        "
                    >
                        <li
                            *ngFor="
                                let price of venueService.pitchData?.data
                                    .attributes.payment
                            "
                        >
                            <p class="small">
                                <strong>
                                    <span class="">{{ price.key }}</span>
                                    {{ price.value }}
                                </strong>
                            </p>
                            <p class="small text-muted">
                                {{ price.desc1 }}
                            </p>
                            <p class="small text-muted">
                                {{ price.desc2 }}
                            </p>
                            <hr />
                        </li>
                    </ul>
                    <p
                        class="small"
                        *ngIf="
                            venueService.pitchData?.data.attributes.payment
                                .length == 0
                        "
                    >
                        Prices on request
                    </p>
                </div>

                <div
                    *ngIf="hasValidTransport"
                >
                    <h3 class="sg-heading__h4">Public Transport</h3>
                    <p class="small">
                        <mlp-ng-icon name="check-1"></mlp-ng-icon>
                        {{
                            venueService.venueData?.data.attributes.nearest_tube
                        }}
                    </p>
                </div>
            </div>

            <div class="col-sm-6">
                <div
                    *ngIf="
                        venueService.venueData?.data.attributes.opening_hours
                    "
                >
                    <h3 class="sg-heading__h4">Opening Hours</h3>

                    <table
                        class="table table-borderless"
                        *ngIf="
                            venueService.venueData?.data.attributes
                                .opening_hours.mon
                        "
                    >
                        <tbody>
                            <tr>
                                <td>Monday</td>
                                <td class="">
                                    {{
                                        venueService.venueData?.data.attributes
                                            .opening_hours.mon
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td>Tuesday</td>
                                <td>
                                    {{
                                        venueService.venueData?.data.attributes
                                            .opening_hours.tue
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td>Wednesday</td>
                                <td>
                                    {{
                                        venueService.venueData?.data.attributes
                                            .opening_hours.wed
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td>Thursday</td>
                                <td>
                                    {{
                                        venueService.venueData?.data.attributes
                                            .opening_hours.thr
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td>Friday</td>
                                <td>
                                    {{
                                        venueService.venueData?.data.attributes
                                            .opening_hours.fri
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td>Saturday</td>
                                <td>
                                    {{
                                        venueService.venueData?.data.attributes
                                            .opening_hours.sat
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td>Sunday</td>
                                <td>
                                    {{
                                        venueService.venueData?.data.attributes
                                            .opening_hours.sun
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <p
                        *ngIf="
                            !venueService.venueData?.data.attributes
                                .opening_hours.mon
                        "
                        class="small"
                    >
                        {{
                            venueService.venueData?.data.attributes
                                .opening_hours
                        }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card pf-card" *ngIf="venueService.pitchData?.data.attributes.about">
    <div class="card-header" role="tab">
        <h2 class="sg-heading__h4 mb-0">Description</h2>
    </div>

    <div class="card-body">
        <p
            [innerHtml]="
                venueService.pitchData?.data.attributes.about | newLine
            "
            class="d-none d-md-block"
        ></p>
        <p
            [innerHtml]="
                add3dots(venueService.pitchData?.data.attributes.about)
                    | newLine
            "
            class="d-md-none"
        ></p>
        <a
            href=""
            (click)="showMoreClick()"
            *ngIf="
                venueService.pitchData?.data.attributes.about &&
                venueService.pitchData?.data.attributes.about.length >
                    showMoreLimit &&
                !showMore
            "
            class="d-md-none sg-link cursor pointer"
            >Show more</a
        >
    </div>
</div>
